import { Outlet, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { adminStaffRoles } from '@anytag/shared-constants';
import { InstagramHashtagsAnalyticsSearchSchema, TiktokTagsAnalyticsSearchSchema } from '@anytag/shared-organisms';
import {
  InstagramHashtagsAnalytics,
  TiktokKeywordAnalytics,
  TiktokHashtagsAnalytics,
  PermissionRoute
} from '@anytag/app';
import { PartialRouter } from '../../types';

export const HashtagAnalyticsRouter = {
  '/_private-routes/hashtag-analytics': [() => <PermissionRoute permissions={adminStaffRoles} />, {}],
  '/_private-routes/hashtag-analytics/': [
    () => <Outlet />,
    {
      beforeLoad: () => {
        throw redirect({ to: '/hashtag-analytics/instagram' });
      }
    }
  ],
  '/_private-routes/hashtag-analytics/instagram': [() => <Outlet />, {}],
  '/_private-routes/hashtag-analytics/instagram/': [
    InstagramHashtagsAnalytics,
    { validateSearch: zodValidator(InstagramHashtagsAnalyticsSearchSchema) }
  ],
  '/_private-routes/hashtag-analytics/instagram/$countryId': [
    InstagramHashtagsAnalytics,
    { validateSearch: zodValidator(InstagramHashtagsAnalyticsSearchSchema) }
  ],
  '/_private-routes/hashtag-analytics/tiktok': [() => <Outlet />, {}],
  '/_private-routes/hashtag-analytics/tiktok/': [
    () => <Outlet />,
    {
      beforeLoad: () => {
        throw redirect({ to: '/hashtag-analytics/tiktok/hashtag' });
      }
    }
  ],
  '/_private-routes/hashtag-analytics/tiktok/keyword': [() => <Outlet />, {}],
  '/_private-routes/hashtag-analytics/tiktok/keyword/': [
    TiktokKeywordAnalytics,
    { validateSearch: zodValidator(TiktokTagsAnalyticsSearchSchema) }
  ],
  '/_private-routes/hashtag-analytics/tiktok/keyword/$countryId': [
    TiktokKeywordAnalytics,
    { validateSearch: zodValidator(TiktokTagsAnalyticsSearchSchema) }
  ],
  '/_private-routes/hashtag-analytics/tiktok/hashtag': [() => <Outlet />, {}],
  '/_private-routes/hashtag-analytics/tiktok/hashtag/': [
    TiktokHashtagsAnalytics,
    { validateSearch: zodValidator(TiktokTagsAnalyticsSearchSchema) }
  ],
  '/_private-routes/hashtag-analytics/tiktok/hashtag/$countryId': [
    TiktokHashtagsAnalytics,
    { validateSearch: zodValidator(TiktokTagsAnalyticsSearchSchema) }
  ]
} as const satisfies PartialRouter;
